export const sendMessage = (type, content) => {
    if (window && window.top) {
        window.top.postMessage(JSON.stringify({ type, data: { ...content, newStackMessage: true } }), '*')
    }
}
